import React, {useEffect, useState} from 'react';
import {Box, Card, CardContent, CircularProgress, Grid2, Typography} from '@mui/material';
import {IInvoice} from '../../../store/apis/interfaces/invoice';
import {useAccount} from '@azure/msal-react';
import {styles} from '@invoice-system';
import {t} from 'ttag';

interface InvoiceDetailsProps {
  data: IInvoice;
  downloadPdf: ({ticket, employeeId}: {ticket: string, employeeId: string}) => any;
}

export const InvoicePreview = ({data, downloadPdf}: InvoiceDetailsProps) => {
  const account = useAccount();
  const [fileUrl, setFileUrl] = useState<string | null>(null);

  useEffect(() => {
    if (data?.docId) {
      downloadPdf({
        ticket: data?.ticket,
        employeeId: account?.username?.split('@')[0] as string
      })
        .unwrap()
        .then((response: any) => {
          if (response) {
            const blob = new Blob([response!], {type: 'application/pdf'});
            const url = window.URL.createObjectURL(blob);
            setFileUrl(url);
          }
        });
    }
  }, [data?.docId, downloadPdf]);

  if (data.sequence === '0' || !data.sequence) {
    return null;
  }

  return (
    <>
      <Typography sx={styles.subtitle} my={2}>{t`Invoice Preview`}</Typography>
      <Card variant={'outlined'} sx={{height: 'auto'}}>
        <CardContent>
          <Grid2 container spacing={{xs: 3, md: 1}}>
            {fileUrl ? (
              <div style={{minHeight: '500px', maxHeight: '5100px', width: '100%', overflowY: 'visible'}}>
                <iframe
                  id={'preview-document'}
                  src={`${fileUrl}#toolbar=0&navpanes=0`}
                  frameBorder='0'
                  width='100%'
                  height='1000px'
                  title='Invoice Preview'
                />
              </div>
            ) : (
              <Box display={'flex'} width={'100%'} height={'175px'} alignItems={'center'} justifyContent={'center'}>
                <CircularProgress sx={{color: '#9E9E9E'}} size={40} />
              </Box>
            )}
          </Grid2>
        </CardContent>
      </Card>
    </>
  );
};
